// Keep in sync with AllowListOutSchema
export type AllowlistEntry = {
  id: string;
  // null: every site (the global allow-list).
  siteId: string | null;
  vehicleRegistration: string;
  startsAt: Date | null;
  endsAt: Date | null;
  note: string | null;
  lastUsedAt: Date | null;
  totalUses: number;
  // Also on the Disallow List, which wins: this entry will not open the barrier.
  onDisallowList: boolean;
};

// The form's site option for a global entry; sent to the API as siteId null.
export const ALL_SITES = "all";

export const parseAllowlistEntry = (
  allowlistEntry: RecursivelyConvertDatesToStrings<AllowlistEntry>,
): AllowlistEntry => ({
  ...allowlistEntry,
  startsAt: allowlistEntry.startsAt
    ? DateFns.parseISO(allowlistEntry.startsAt)
    : null,
  endsAt: allowlistEntry.endsAt
    ? DateFns.parseISO(allowlistEntry.endsAt)
    : null,
  lastUsedAt: allowlistEntry.lastUsedAt
    ? DateFns.parseISO(allowlistEntry.lastUsedAt)
    : null,
});
